<template>
      <div class="container bg-gray-100 p-5">
        <router-link type="button" class="hover:underline" to="/">
            <svg class="h-8 w-8 fill-current text-blue-900" xmlns="http://www.w3.org/2000/svg" viewBox="274.835 394.86 54.965 55.15"><defs/><path d="M302.4 395.823c14.752.013 26.694 12.004 26.695 26.805.001 14.592-12.041 26.517-26.753 26.495-14.737-.023-26.754-11.98-26.684-26.551.072-14.873 11.958-26.763 26.742-26.749zm.342 32.534h2.447c3.522 0 7.044.033 10.565-.013 2.327-.03 3.413-1.138 3.479-3.442.039-1.364.033-2.731.003-4.096-.057-2.537-.978-3.536-3.514-3.605-2.801-.076-5.605-.022-8.408-.024-1.471-.001-2.942 0-4.571 0 0-1.899.247-3.457-.079-4.885-.254-1.114-1.01-2.527-1.934-2.949-.783-.357-2.422.2-3.171.899-3.518 3.284-6.88 6.737-10.254 10.171-1.618 1.646-1.652 3.053-.056 4.689 3.413 3.497 6.829 6.997 10.403 10.326.73.68 2.361 1.107 3.203.755.868-.363 1.601-1.754 1.812-2.811.3-1.513.075-3.132.075-5.015z"/></svg>
        </router-link>
          <div class="container bg-white rounded-lg p-5 box-shadow">
            <p class="text-gray-700 text-center text-2xl lg:text-4xl mb-5">Accidentes personales</p>
            <p class="text-gray-600 text-center text-lg lg:text-xl">
                Puedes aumentar o disminuir con el slider la suma asegurada que deseas recibir.
            </p>

            <div class="">

                  <!-- <vue-range-slider v-model="value"></vue-range-slider> -->


        <div class="w-1/2 mt-2 mb-2" style="float: right;">
            <vue-range-slider :bg-style="bgStyle" :min="min" :max="max" :tooltip-style="tooltipStyle" :process-style="processStyle" v-model="value"></vue-range-slider>
        </div>

        <table class="mt-5 mb-5" style="width:100%">
          <tr v-for="benefit in benefits.result[value].benefits" :key="benefit.id">
            <td class="text-xs lg:text-base text-gray-800">{{benefit.name}}</td>

            <td class="text-xs lg:text-base text-gray-800" style="text-align: left;">{{$filters.toCurrency(benefit.sum_assured)}}</td>
          </tr>
        </table>


<!-- 
                <table class="mt-5 mb-5" style="width:100%">
          <tr>
            <td class="text-lg lg:text-base text-gray-800" >Muerte Accidental</td>
            <td class="text-lg lg:text-base text-gray-800" style="text-align: left;">{{$filters.toCurrency(value)}}</td>
          </tr>
            <tr>
            <td class="text-sm lg:text-base text-gray-800" >Pérdidas orgánicas</td>
            <td class="text-sm lg:text-base text-gray-800" style="text-align: left;">{{$filters.toCurrency(value)}}</td>
          </tr>
            <tr>
            <td class="text-sm lg:text-base text-gray-800" >Gastos para el Hogar</td>
            <td class="text-sm lg:text-base text-gray-800" style="text-align: left;">{{$filters.toCurrency(value)}}</td>
          </tr>
            <tr>
            <td class="text-sm lg:text-base text-gray-800" >Gastos para Educación</td>
            <td class="text-sm lg:text-base text-gray-800" style="text-align: left;">{{$filters.toCurrency(value)}}</td>
          </tr>
        </table> -->

            <p class="text-2xl text-center text-gray-800">Prima quincenal</p>
            <p class="text-4xl text-center text-green-500 italic mt-5">{{$filters.toCurrency(this.benefits.result[value].costo)}}</p>


            <div class="w-full p-2 text-center mt-5 mb-2">
                <button class="w-full bg-orange-600 hover:bg-orange-700 text-2xl text-white font-bold py-4 px-6 rounded">
                    Contratar <md-icon>arrow_forward_ios</md-icon>
                </button>
            </div>

            </div>

          </div>










        <div class="container bg-white rounded-lg mt-5 p-5 box-shadow">
            <p class="text-gray-700 text-center text-2xl lg:text-4xl mb-5">Accidentes personales</p>
            <p class="text-gray-600 text-center text-lg lg:text-xl">
                Puedes aumentar o disminuir con el más y menos la suma asegurada que deseas recibir.
            </p>

            <div class="">

        <table class="mt-5 mb-5" style="width:100%">
          <tr v-for="benefit in benefits.result[value].benefits" :key="benefit.id"> 
            <td class="text-xs md:text-base lg:text-base text-gray-800" >{{benefit.name}}</td>
            <td style="text-align: left;"> 
              <button v-if="!(value == min)" v-on:click="value -= 1" class="text-xl text-red-500">-</button> 
            </td>
            <td class="text-xs md:text-base lg:text-base text-gray-800" style="text-align: left;"> 
              {{$filters.toCurrency(benefit.sum_assured)}}
            </td>
            <td style="text-align: left;"> 
              <button v-if="value < max" v-on:click="value += 1" class="text-xl text-green-500">+</button>            
            </td>
          </tr>
        </table>

                <!-- <table class="mt-5 mb-5" style="width:100%">
          <tr>
            <td class="text-lg lg:text-base text-gray-800" >Muerte Accidental</td>
            <td class="text-lg lg:text-base text-gray-800" style="text-align: left;"> <button v-on:click="value -= 1">-</button> {{$filters.toCurrency(value)}} <button v-on:click="value += 1">+</button></td>
          </tr>
            <tr>
            <td class="text-sm lg:text-base text-gray-800" >Pérdidas orgánicas</td>
            <td class="text-sm lg:text-base text-gray-800" style="text-align: left;">{{$filters.toCurrency(value)}}</td>
          </tr>
            <tr>
            <td class="text-sm lg:text-base text-gray-800" >Gastos para el Hogar</td>
            <td class="text-sm lg:text-base text-gray-800" style="text-align: left;">{{$filters.toCurrency(value)}}</td>
          </tr>
            <tr>
            <td class="text-sm lg:text-base text-gray-800" >Gastos para Educación</td>
            <td class="text-sm lg:text-base text-gray-800" style="text-align: left;">{{$filters.toCurrency(value)}}</td>
          </tr>
        </table> -->

            <p class="text-2xl text-center text-gray-800">Prima quincenal</p>
            <p class="text-4xl text-center text-green-500 italic mt-5">{{$filters.toCurrency(this.benefits.result[value].costo)}}</p>


            <div class="w-full p-2 text-center mt-5 mb-2">
                <button class="w-full flex justify-center items-center bg-orange-600 hover:bg-orange-700 text-2xl text-white font-bold py-2 px-6 rounded">
                    Contratar <mdicon name="chevron-right" />
                </button>
            </div>

            </div>

          </div>






<div class="container bg-white rounded-lg mt-5 p-5 box-shadow">
            <p class="text-gray-700 text-center text-2xl lg:text-4xl mb-5">Accidentes personales</p>
            <p class="text-gray-600 text-center text-lg lg:text-xl">
                Selecciona la cantidad que deseas recibir de beneficio
            </p>

                            <select class="w-full shadow appearance-none border rounded mt-4 text-grey-darker">
                    <option value disabled>Seleccione una opción</option>
                    <option v-for="s in listaBeneficios" :key="s.id" >{{s.sum_assured}}</option>
                </select>

            <v-select 
            :searchable="false"
            class="w-full shadow appearance-none border rounded mt-4 text-grey-darker" label="result" :options="[listaBeneficios]">
                <template v-slot:no-options>
                    <template>
                        No hay resultados.
                    </template>
                </template>
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                      {{ option.sum_assured }}
                  </div>
    </template>
            </v-select>

            <div class="">

        <table class="mt-5 mb-5" style="width:100%">
          <tr>
            <td class="text-lg lg:text-base text-gray-800" >Muerte Accidental</td>
            <td class="text-lg lg:text-base text-gray-800" style="text-align: left;"> {{$filters.toCurrency(value)}} </td>
          </tr>
            <tr>
            <td class="text-sm lg:text-base text-gray-800" >Pérdidas orgánicas</td>
            <td class="text-sm lg:text-base text-gray-800" style="text-align: left;">{{$filters.toCurrency(value)}}</td>
          </tr>
            <tr>
            <td class="text-sm lg:text-base text-gray-800" >Gastos para el Hogar</td>
            <td class="text-sm lg:text-base text-gray-800" style="text-align: left;">{{$filters.toCurrency(value)}}</td>
          </tr>
            <tr>
            <td class="text-sm lg:text-base text-gray-800" >Gastos para Educación</td>
            <td class="text-sm lg:text-base text-gray-800" style="text-align: left;">{{$filters.toCurrency(value)}}</td>
          </tr>
        </table>

            <p class="text-2xl text-center text-gray-800">Prima quincenal</p>
            <p class="text-4xl text-center text-green-500 italic mt-5">$58.00</p>


            <div class="w-full p-2 text-center mt-5 mb-2">
                <button class="w-full bg-orange-600 hover:bg-orange-700 text-2xl text-white font-bold py-4 px-6 rounded">
                    Contratar <md-icon>arrow_forward_ios</md-icon>
                </button>
            </div>

            </div>

          </div>


      </div>
</template>

<script>



import JsonObjeto from '../assets/cober.json';





export default {
  name: 'Benefit',

  data() {
    return {
        benefits: JsonObjeto,
        listaBeneficios: null,
        jsonLength: null,
        value: 0,
        benefitAmount: ["$100,000.00", "$200,000.00", "$300,000.00", "$400,000.00"]
        }
    },
    
  created() {
    this.getString();
    this.min = 0
    this.max = this.jsonLength
    this.bgStyle = {
     backgroundColor: '#fff',
     boxShadow: 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)'
    }
    this.tooltipStyle = {
    display: 'none',
      backgroundColor: '#666',
      borderColor: '#666'
    }
    this.processStyle = {
      backgroundColor: '#999'
    }
  },
  methods:{
    getString(){
            console.log(this.benefits);

      this.jsonLength = this.benefits.result.length -1
      console.log(this.jsonLength);
      this.listaBeneficios = this.benefits.result

      console.log(this.listaBeneficios)
    }
  }
}
</script>

<style scoped>
.box-shadow {
    border: 1px ;
    padding: 10px;
    box-shadow: 2px 10px 8px #888888;
}

</style>